import React from 'react';
import {Styles} from '../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from "react-router";
import {withSnackbar} from "notistack";
import {connect, setStore} from "trim-redux";
import {FieldSkeleton} from "../Skeletons/FieldSkeleton";
import ChipInput from "material-ui-chip-input";
import InputAdornment from "@material-ui/core/InputAdornment/InputAdornment";
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import Typography from "@material-ui/core/Typography/Typography";
import {Translate} from "../../../config/Translate"
import FieldCounterWithoutBar from "../elements/FieldCounterWithoutBar";
import axios from "axios";
import {defaultVariabls} from "../../../config";
import MenuItem from "@material-ui/core/MenuItem/MenuItem";
import TextField from "@material-ui/core/TextField/TextField";
class SizeChooser extends React.Component {
    classes = this.props.classes
    state={
        sizes: [],
        error:null,
        loading:true,
        size:this.props.input
    };
    componentDidMount(){
        this.setState({
            size:this.props.input
        })
        this.loadData();
    }
    async loadData(){
        let loginToken = localStorage.getItem('ACT');
        if(loginToken !== null){
            let config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`
                }
            };
            await axios.get(`${defaultVariabls.url}/sizes/getAll`, config)
                .then(response => {
                    this.setState({
                        sizes: response.data,
                        loading:false,
                    })

                }).catch(error => {
                    console.log(error.response)
                    this.setState({
                        loading:false
                    })
                })
        }else {
            setStore({
                isAuth : false,
                user : null,
            });
            this.setState({
                loading:false
            })
        }
    }
    handleChange(e){
        let val = e.target.value;
        this.setState({
            size:val
        })
        this.props.output(val);
    }
    render() {
        let {loading,size,sizes} = this.state;
        let{disabled} = this.props;
        return(
            <>
                <TextField
                    variant="outlined"
                    size="small"
                    value={size}
                    fullWidth
                    select
                    disabled={disabled}
                    label={Translate.size}
                    name="size"
                    onChange={this.handleChange.bind(this)}
                    InputProps={loading && {
                        startAdornment: (
                            <InputAdornment position="start">
                                <CircularProgress size={16}/>
                            </InputAdornment>
                        ),
                    }}
                >
                    {
                        sizes.map((item,index) =>
                            <MenuItem key={index} value={item.name}>
                                {item.description} <span className="menu_sub"> ({item.information})</span>
                            </MenuItem>
                        )
                    }
                </TextField>
            </>
        )
    }
}
const mstp = state => ({
    Translate: state.Translate,
    locale: state.locale,
});
export default withRouter(withSnackbar(withStyles(Styles)(connect(mstp)(SizeChooser))));